import { Sizing_Pumping_Type_Enum } from "gql/api";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderSizingInfoCols: RenderScenarioExportCols = ({
  scenario,
  sizing,
  isPerfEval
}) => {
  const isHPS = sizing?.pumping_type === Sizing_Pumping_Type_Enum.Hps;

  return [
    {
      section: "Sizing Info",
      label: "Sizing Name",
      targetUnit: null,
      value: sizing?.title
    },
    {
      section: "Sizing Info",
      label: "Export Date",
      targetUnit: null,
      value: new Date().toLocaleDateString("en-us")
    },
    {
      section: "Sizing Info",
      label: "User Name / ID",
      targetUnit: null,
      value: `${sizing?.author?.display_name} / ${sizing?.author?.email}`
    },
    {
      section: "Sizing Info",
      label: isHPS ? "Location" : "Well Name",
      targetUnit: null,
      value: isHPS ? sizing?.hps_location : sizing?.well?.well_name
    },
    {
      section: "Sizing Info",
      label: "Customer ",
      targetUnit: null,
      value: sizing?.customer?.customer_name
    },
    {
      section: "Sizing Info",
      label: "Notes",
      targetUnit: null,
      value: sizing?.notes
    },
    {
      section: "Sizing Info",
      label: "Scenario Title",
      targetUnit: null,
      value: scenario.scenario.value?.title
    },
    {
      section: "Sizing Info",
      label: "Unit System",
      targetUnit: null,
      value: sizing?.default_display_units
    },
    {
      section: "Sizing Info",
      label: "Disposition",
      targetUnit: null,
      value: sizing?.disposition
    },
    {
      section: "Sizing Info",
      label: "Tender / Quote / Etc",
      targetUnit: null,
      value: isPerfEval ? "Eval" : scenario.scenario.value?.reason
    }
  ];
};
